import React from 'react';
import {BrowserRouter as Router,Route} from 'react-router-dom';
import Switch from "react-router-dom/es/Switch";

import Confirm from './Confirm'
import './App.css';

class App extends React.Component {
    render(){
        return (
            <Router>
                <div className="initial">
                    <Switch>
                        <Route
                            exact path={"/"}
                            component={Confirm}
                        />
                        <Route
                            path={"/:token"}
                            component={Confirm}
                        />
                    </Switch>
                </div>
            </Router>

        )
    }


  // return (
  //   <div className="App">
  //     <header className="App-header">
  //       <img src={logo} className="App-logo" alt="logo" />
  //       <p>
  //         Edit <code>src/App.js</code> and save to reload.
  //       </p>
  //       <a
  //         className="App-link"
  //         href="https://reactjs.org"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         Learn React
  //       </a>
  //     </header>
  //   </div>
  // );
}

export default App;
